import { useTheme } from "../context/ThemeContext";

const useIsDarkMode = () => useTheme().theme === "dark";

export default useIsDarkMode;

